<template>
  <div class="home">
    <Section light>
      <h1>Apply</h1>
      <v-col class="px-4" cols="12">
        <!-- <p>
          Applications for the 2025-2026 season are now closed. Thanks to all of
          our applicants.
          Keep up with what we are doing on our
          <a target="_blank" href="https://www.instagram.com/yonderdynamics/"
            >Instagram</a
          >!
        </p> -->
        <p>
          Our application for the 2026-2027 season is now open! Apply <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeafR0AfzTdKzEQfA5Ua9tDNp2EJuMX5LQWS6M7LI-oenVVUQ/viewform?usp=header">here</a>.
          <br />
          Applications close October 9th at 11:59 PM
        </p>
      </v-col>

      <!-- Mechanical Subteam -->
      <v-col cols="12" class="subteam-section">
        <h1>Mechanical</h1>
        <v-col class="px-4" cols="12">
          <p>
            The main goal of the mechanical subteam is to provide a
            collaborative learning environment for members of all levels of
            experience by designing and producing successful physical components
            of the rover.
          </p>
          <v-img
            class="shrink mx-auto mb-4"
            contain
            :max-width="450"
            :src="require('@/assets/mechanical/overview.jpg')"
          />
          <div class="learn-more-center">
            <div class="learn-more-btn" @click="toggle('mech')">
              <span>{{ expanded.mech ? 'Hide details' : 'Learn more' }}</span>
            </div>
          </div>
          <v-expand-transition>
            <div v-show="expanded.mech" class="details">
              <br />
              <p>
                Our initial design phase is based on discussion and research in
                a collaborative environment. We use SOLIDWORKS to model
                components and create the full rover assembly, which are
                imported into ANSYS, Altair Inspire, and MotionView for FEA and
                MBD analyses. We emphasize designing for manufacturability and
                performance on the rover.
              </p>

              <p>
                Rover components are also manufactured by our team members,
                using machinery and tools such as:
              </p>
              <ul>
                <li>CNC and manual mills</li>
                <li>3D printers</li>
                <li>Laser cutters</li>
                <li>Bandsaws</li>
                <li>Drill presses</li>
                <li>Power and hand tools</li>
                <li>Welding</li>
              </ul>
              <div class="mt-5">
                <h2>Arm Module</h2>
                <p>
                  Our current arm was fully redesigned and built from scratch
                  during the 2021-2022 year. This year, we aim to completely and
                  fundamentally redesign the entire arm, aiming to improve its
                  precision, reliability, and optimization. Some of the
                  requirements for the arm demanded by the competition include:
                </p>
                <ul>
                  <li>Lifting heavy (5kg+) objects</li>
                  <li>Typing on a keyboard</li>
                  <li>Manipulating tools and switches</li>
                  <li>Inserting a USB stick</li>
                  <li>Collecting soil samples</li>
                </ul>
                <v-img
                  :aspect-ratio="1 / 1"
                  class="shrink mx-auto"
                  contain
                  :max-width="450"
                  :src="require('@/assets/mechanical/arm.jpg')"
                />
              </div>
              <div class="mt-5">
                <h2>Science Module</h2>
                <p>
                  The science team communicates their research and design needs
                  so that the mechanical team can design the hardware to
                  implement the necessary experiments for competition. Last
                  year, we built a carousel of cuvettes. A custom scoop deposited
                  soil samples into a large funnel that separated the sample into
                  four cuvettes so that multiple tests could be run on one
                  sample. The carousel rotated after every sample was deposited
                  allowing us to run the same four tests on multiple samples. A
                  cache collection system was also designed by mechanical so that
                  a sample could be collected and returned to the judges. Each
                  individual cuvette had to be mixed, kept away from light, and
                  spill proof.
                </p>
                <v-img
                  :aspect-ratio="1 / 1"
                  class="shrink mx-auto"
                  contain
                  :max-width="450"
                  :src="require('@/assets/mechanical/science.jpg')"
                />
              </div>
              <div class="mt-5">
                <h2>Chassis</h2>
                <p>
                  Our current chassis was designed and built during the
                  2022-2023 school year. Our new lightweight, aluminum TIG
                  welded chassis sports a rocker-bogie suspension system with a
                  sturdy differential bar. With these upgrades, Lethargy easily
                  tackled steep angles, rocky hills, and rough terrain during the
                  URC.
                </p>
                <v-img
                  class="shrink mx-auto"
                  contain
                  :max-width="450"
                  :src="require('@/assets/mechanical/comp_chassis.jpg')"
                />
              </div>
            </div>
          </v-expand-transition>
        </v-col>
      </v-col>

      <!-- Electrical Subteam -->
      <v-col cols="12" class="subteam-section">
        <h1>Electrical</h1>
        <v-col class="px-4 mt-4 col-12">
          <p>
            The electrical team focuses on reliable power, networking, and
            electronics that keep the rover running. We iterate through design,
            manufacturing, and testing to add new capabilities while maintaining
            uptime for the other subteams.
          </p>
          <v-img
            class="shrink mx-auto mb-4"
            contain
            :max-width="450"
            :src="require('@/assets/electrical/generic.jpg')"
          />
          <div class="learn-more-center">
            <div class="learn-more-btn" @click="toggle('elec')">
              <span>{{ expanded.elec ? 'Hide details' : 'Learn more' }}</span>
            </div>
          </div>
          <v-expand-transition>
            <div v-show="expanded.elec" class="details">
              <v-row>
                <v-col class="px-4 mt-4 col-md-6 col-12">
                  <h2>Wireless</h2>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :src="require('@/assets/electrical/driving_sm.gif')"
                    max-height="500px"
                  />
                  <p>
                    Our high-speed 5.8 GHz wireless link remains functional at
                    1 km+ while streaming low-latency, high-quality video.
                  </p>
                  <h2>Arm</h2>
                  <p>
                    Compact arm electronics enable standalone testing with a
                    battery and laptop, made possible via detailed 3D modeling
                    and PCB design.
                  </p>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :src="require('@/assets/electrical/arm.jpg')"
                    max-height="500px"
                  />
                  <h2>Ongoing + Upcoming</h2>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :src="require('@/assets/electrical/wireless.png')"
                    max-height="500px"
                  />
                  <p>
                    We are integrating arm electronics, co-designing PCBs and
                    chassis, and adding pervasive sensing (temperature,
                    current, redundant position) to improve robustness.
                  </p>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :src="require('@/assets/electrical/sensing.jpg')"
                    max-height="500px"
                  />
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-col>
      </v-col>

      <!-- Software Subteam -->
      <v-col cols="12" class="subteam-section">
        <h1>Software</h1>
        <v-col cols="12">
          <p>
            The software subteam builds everything from autonomous
            navigation to operator tools. We work across vision, planning,
            controls, and UI in close collaboration with the other
            subteams.
          </p>
          <v-img
            class="shrink mx-auto mb-4"
            contain
            :max-width="450"
            :src="require('@/assets/software/autonomous.jpg')"
          />
          <div class="learn-more-center">
            <div class="learn-more-btn" @click="toggle('soft')">
              <span>{{ expanded.soft ? 'Hide details' : 'Learn more' }}</span>
            </div>
          </div>
          <v-expand-transition>
            <div v-show="expanded.soft" class="details">
              <v-col cols="12"><h2>Autonomous Navigation</h2></v-col>
              <v-row>
                <v-col class="px-4 col-md-6 col-12">
                  <ul>
                    <li>Navigate to GPS waypoints within a few meters</li>
                    <li>AR tag and object detection (CNN-based)</li>
                    <li>Continuous tag estimation with filtering</li>
                    <li>Return-to-post behavior; Kalman-based localization</li>
                    <li>Efficient exploration of unknown terrain</li>
                  </ul>
                  <p>Tech: ROS, C++, STM32, OctoMap, ESKF, PyTorch</p>
                </v-col>
              </v-row>
              <v-col cols="12"><h2>UI</h2></v-col>
              <v-row>
                <v-col class="px-4 col-md-6 col-12">
                  <ul>
                    <li>Web-based control panel with controller support</li>
                    <li>Real-time video, science payload control</li>
                    <li>Battery/status monitoring; mapping and planning</li>
                  </ul>
                  <p>Tech: React, WebSockets</p>
                </v-col>
                <v-col class="px-4 col-md-6 col-12">
                  <v-img
                    class="shrink mx-auto"
                    :max-height="450"
                    contain
                    :src="require('@/assets/software/ui.png')"
                  />
                </v-col>
              </v-row>
              <v-col cols="12"><h2>Arm</h2></v-col>
              <v-row>
                <v-col class="px-4 col-md-6 col-12">
                  <v-img
                    class="shrink mx-auto"
                    :max-height="450"
                    contain
                    :src="require('@/assets/software/arm.jpg')"
                  />
                </v-col>
                <v-col class="px-4 col-md-6 col-12">
                  <ul>
                    <li>Forward/Inverse Kinematics with PID</li>
                    <li>Autonomous pose sequences; arm simulation</li>
                  </ul>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-col>
      </v-col>

      <!-- Science Subteam -->
      <v-col cols="12" class="subteam-section">
        <h1>Science</h1>
        <v-col cols="12">
          <p>
            The science subteam researches and builds experiments for life
            detection on Mars analog samples, coordinating closely with other
            subteams to integrate our science module.
          </p>
          <v-img
            class="shrink mx-auto mb-4"
            contain
            :max-width="450"
            :src="require('@/assets/science/generic1.jpg')"
          />
          <div class="learn-more-center">
            <div class="learn-more-btn" @click="toggle('sci')">
              <span>{{ expanded.sci ? 'Hide details' : 'Learn more' }}</span>
            </div>
          </div>
          <v-expand-transition>
            <div v-show="expanded.sci" class="details">
              <v-col cols="12">
                <p>
                  We survey literature, develop protocols, design instruments,
                  and test samples to classify them as extinct, extant, or no
                  life, also analyzing geologic evidence of water. The rover can
                  cache and deliver interesting samples to judges.
                </p>
                <v-img
                  class="shrink mx-auto"
                  contain
                  :max-width="450"
                  :src="require('@/assets/science/carosel.jpg')"
                />
                <h2>Assays: Fluorometry</h2>
                <p>
                  We run DAPI and Nile Red stains and built a spectrometer to
                  detect fluorescence.
                </p>
                <h2>Optics: Raman</h2>
                <p>
                  Our Raman spectrometer detects biosignature molecules and
                  integrates with the electrical team for telemetry.
                </p>
              </v-col>
              <v-row>
                <v-col class="px-4 col-md-6 col-12">
                  <p text-align="center">Collecting a soil sample.</p>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :max-width="450"
                    :src="require('@/assets/science/collection.jpg')"
                  />
                </v-col>
                <v-col class="px-4 col-md-6 col-12">
                  <p text-align="center">Loading a sample into the funnel.</p>
                  <v-img
                    class="shrink mx-auto"
                    contain
                    :max-width="450"
                    :src="require('@/assets/science/funnel.jpg')"
                  />
                </v-col>
              </v-row>
              <v-col cols="12">
                <p>
                  Members gain experience in research, writing, running lab
                  experiments, coding/bioinformatics, and hands-on mechanical
                  work.
                </p>
              </v-col>
            </div>
          </v-expand-transition>
        </v-col>
      </v-col>

      <div class="page-fill"></div>
    </Section>
  </div>
</template>

<script>
import Section from '@/components/Section.vue';

export default {
  name: 'Recruitment',
  components: {
    Section,
  },
  data() {
    return {
      expanded: {
        mech: false,
        elec: false,
        soft: false,
        sci: false,
      },
    };
  },
  methods: {
    toggle(key) {
      this.$set(this.expanded, key, !this.expanded[key]);
    },
  },
};
</script>

<style scoped>
h1 { text-align: center; }
h2 { text-align: center; }
a { color: white; }
a:visited { color: white; }
a:link { color: white; }

.button-container { display: flex; justify-content: center; align-items: center; }
.apply-button {
  background-color: #1f1a2e;
  border: 2px solid #1f1a2e;
  color: white;
  padding: 15px 32px;
  text-align: center;
  font-size: 32px;
  border-radius: 15px;
  cursor: pointer;
  text-decoration: none;
  transition: 0.3s;
}
.apply-button:hover { background-color: white; color: #1f1a2e; }
.apply-button a { color: inherit; text-decoration: none; }

.subteam-section {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
}
.page-fill { height: 85vh; }

/* Learn More styling */
.learn-more-center {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.learn-more-btn {
  font-size: 36px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  text-align: center;
  position: relative;
  padding: 8px 16px;
  transition: all 300ms ease;
}
.learn-more-btn::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 4px;
  background: linear-gradient(90deg, #8b7bd9, var(--medium));
  border-radius: 2px;
  transition: width 300ms ease;
}
.learn-more-btn:hover::after {
  width: 100%;
}
.learn-more-btn:hover {
  color: #f0f0f0;
}
.details { margin-top: 16px; }
</style>
